<!-- A Component used to represent the Shipping Method chosen for the the Customer Purchase.
Based on the received shipmentCode, an icon is displayed. -->

<template>
    <v-icon v-if="shipmentCode === 3">fal fa-store-alt</v-icon>
    <v-icon v-else-if="shipmentCode === 1">fal fa-truck</v-icon>
    <v-icon v-else-if="shipmentCode === 2">fal fa-shipping-timed</v-icon>
    <v-icon v-else-if="shipmentCode === 4">fal fa-hand-holding-box</v-icon>
</template>

<script>
    export default {
        name: "OrdersShipment",
        props: {
            shipmentCode: Number
        },
    }
</script>

<style scoped>

</style>